import { useGQL } from 'services/gql';
import { breakoutRoomInviteModel } from '../breakoutRoomInviteModel';
import { breakoutRoomInviteSchema } from '../breakoutRoomInvite/breakoutRoomInviteSchema';
import { breakoutRoomSchema } from './breakoutRoomSchema';
import { userSchema } from 'entities/user/userSchema';

/**
 * voglio recuperare anche la lista degli inviti e di conseguenza gli utenti
 */
const listBrandBreakoutRoomsQuery = /* GraphQL */ `
    query listBrandBreakoutRoomsQuery($id: ID!, $nextToken: String){
        getBrand(id: $id){
            breakoutRooms(nextToken: $nextToken) {
                nextToken 
                items {
                    ${breakoutRoomSchema}
                    speakers {
                      items {
                        id
                        givenName
                        familyName
                        coverImage
                        jobTitle
                      }
                    }
                    invitations(limit: 100000) {
                        items {
                            ${breakoutRoomInviteSchema}
                            user {
                                ${userSchema}
                            }
                        }
                    }
                }
            }            
        }
    }
`;

const getBrQuery = /* GraphQL */ `
  query getBrQuery($id: ID!) {
    getBreakoutRoom(id: $id) {
      id
      coverImage
      description
      type
      date
      end
      start
      brand {
        name
      }
      speakers {
        items {
          id
          givenName
          familyName
          coverImage
          jobTitle
        }
      }
      invitations(limit: 100000) {
        items {
          id
          status
          invitationType
          user {
            email
            familyName
            givenName
            id
          }
        }
      }
      name
    }
  }
`;

const breakoutRoomDeleteSchema = `
    ${breakoutRoomSchema}
    invitations(limit: 100000) {
        items {
            id            
        }
    }
`;

const listBreakoutRoomsForAdminQuery = /* GraphQL */ `
  query listBreakoutRoomsForAdminQuery($nextToken: String) {
    listBreakoutRooms(nextToken: $nextToken) {
      nextToken
      items {
        brand {
          name
        }
        start
        name
        end
        date
        type
        invitations(limit: 100000, filter: { status: { ne: "pending" } }) {
          items {
            id
            status
            invitationType
          }
        }
      }
    }
  }
`;

export const useBreakoutRoomGql = () => {
  const {
    getQuery,
    createMutation,
    updateMutation,
    deleteMutation,
    sendQuery,
  } = useGQL('breakoutRoom');

  //QUERY
  const listBrandBreakoutRooms = (id) =>
    sendQuery('get-by-id', listBrandBreakoutRoomsQuery, { id });

  const listAdminBreakoutRooms = () =>
    sendQuery('list-admin-br', listBreakoutRoomsForAdminQuery, null, true);

  const getBrInfo = (id) => sendQuery('get-br-by-id', getBrQuery, { id });

  //MUTATIONS
  const create = (input) => createMutation(input);

  const update = (input) => updateMutation(input);

  const remove = async (id) => {
    // l'eliminazione della BR deve eliminare anche tutti gli inviti collegati
    const brResponse = await getQuery(id, breakoutRoomDeleteSchema);
    const inputList = [];
    brResponse.invitations.items.map((invite) => {
      inputList.push({ id: invite.id });
    });
    try {
      if (inputList.length > 0)
        await breakoutRoomInviteModel.gql.removeMultiple(inputList);
      await deleteMutation({ id: id });
    } catch (e) {
      console.error('error-delete-breakout-room', e);
    }
  };

  return {
    listBrandBreakoutRooms,
    listAdminBreakoutRooms,
    getBrInfo,
    create,
    update,
    remove,
  };
};
